exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.first_ul li[data-v-6790cf28] {\n    float: left;\n    margin: 0px 25px 15px 0px;\n    height: 30px;\n    line-height: 30px;\n    min-width: 220px;\n    width: 360px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6790cf28","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/physical/physical_org_det.vue
// module id = SXo9
// module chunks = 3